import { jsx as a } from "react/jsx-runtime";
import { useCallback as d } from "react";
import { translate as c } from "./HoopsViewer.utils.mjs";
import "./HoopsViewerContext.mjs";
import { useBundle as v } from "./HoopsViewerContext.hooks.mjs";
import { H as l } from "./HoopsViewerToolbarIcon-C2mCRx_Z.js";
import { PlaneAction as x } from "./HoopsViewerToolbar.types.mjs";
const Y = (t) => {
  const { viewer: o, translation: n, prefix: r, initialized: e, duration: i } = t, { model: s, view: h, sheetManager: k, noteTextManager: p, operatorManager: f } = o, w = v(), V = d(() => {
    (async () => {
      if (s.isDrawing()) {
        const C = k.getActiveSheetId();
        C !== null && await h.isolateNodes([C]);
        return;
      }
      if (!e)
        return;
      await h.setViewOrientation(w.ViewOrientation.Iso, i), p.setIsolateActive(!1), await p.updatePinVisibility();
      const u = f.getOperator(w.OperatorId.Handle);
      u !== null && u.removeHandles && await u.removeHandles();
    })();
  }, [
    w.OperatorId.Handle,
    w.ViewOrientation.Iso,
    i,
    e,
    s,
    p,
    f,
    k,
    h
  ]);
  return /* @__PURE__ */ a(
    l,
    {
      x: 3,
      y: 2,
      hoverX: 2,
      hoverY: 2,
      title: c(n, `${r}reset_to_original_view`, "Reset To Original View"),
      onClick: V
    }
  );
}, M = (t) => {
  const { translation: o, prefix: n } = t;
  return /* @__PURE__ */ a(l, { x: 5, y: 0, hoverX: 4, hoverY: 0, title: c(o, `${n}view`, "View") });
}, P = (t) => {
  const { viewer: o, translation: n, prefix: r } = t, { view: e } = o, i = v(), s = d(() => {
    e.setProjectionMode(i.Projection.Orthographic);
  }, [i.Projection.Orthographic, e]);
  return /* @__PURE__ */ a(
    l,
    {
      x: 5,
      y: 4,
      hoverX: 4,
      hoverY: 4,
      title: c(n, `${r}parallel`, "Parallel"),
      onClick: s
    }
  );
}, $ = (t) => {
  const { viewer: o, translation: n, prefix: r } = t, { view: e } = o, i = v(), s = d(() => {
    e.setProjectionMode(i.Projection.Perspective);
  }, [i.Projection.Perspective, e]);
  return /* @__PURE__ */ a(
    l,
    {
      x: 7,
      y: 4,
      hoverX: 6,
      hoverY: 4,
      title: c(n, `${r}perspective`, "Perspective"),
      onClick: s
    }
  );
}, b = (t) => {
  const { viewer: o, translation: n, prefix: r, duration: e } = t, { view: i } = o, s = v(), h = d(() => {
    i.setViewOrientation(s.ViewOrientation.Iso, e);
  }, [s.ViewOrientation.Iso, e, i]);
  return /* @__PURE__ */ a(
    l,
    {
      x: 5,
      y: 2,
      hoverX: 4,
      hoverY: 2,
      title: c(n, `${r}isometric`, "Isometric"),
      onClick: h
    }
  );
}, S = (t) => {
  const { viewer: o, translation: n, prefix: r, duration: e } = t, { view: i } = o, s = v(), h = d(() => {
    i.setViewOrientation(s.ViewOrientation.Left, e);
  }, [s.ViewOrientation.Left, e, i]);
  return /* @__PURE__ */ a(
    l,
    {
      x: 7,
      y: 2,
      hoverX: 6,
      hoverY: 2,
      title: c(n, `${r}left`, "Left"),
      onClick: h
    }
  );
}, D = (t) => {
  const { viewer: o, translation: n, prefix: r, duration: e } = t, { view: i } = o, s = v(), h = d(() => {
    i.setViewOrientation(s.ViewOrientation.Right, e);
  }, [s.ViewOrientation.Right, e, i]);
  return /* @__PURE__ */ a(
    l,
    {
      x: 1,
      y: 6,
      hoverX: 0,
      hoverY: 6,
      title: c(n, `${r}right`, "Right"),
      onClick: h
    }
  );
}, F = (t) => {
  const { viewer: o, translation: n, prefix: r, duration: e } = t, { view: i } = o, s = v(), h = d(() => {
    i.setViewOrientation(s.ViewOrientation.Bottom, e);
  }, [s.ViewOrientation.Bottom, e, i]);
  return /* @__PURE__ */ a(
    l,
    {
      x: 3,
      y: 0,
      hoverX: 2,
      hoverY: 0,
      title: c(n, `${r}bottom`, "Bottom"),
      onClick: h
    }
  );
}, A = (t) => {
  const { viewer: o, translation: n, prefix: r, duration: e } = t, { view: i } = o, s = v(), h = d(() => {
    i.setViewOrientation(s.ViewOrientation.Front, e);
  }, [s.ViewOrientation.Front, e, i]);
  return /* @__PURE__ */ a(
    l,
    {
      x: 7,
      y: 1,
      hoverX: 6,
      hoverY: 1,
      title: c(n, `${r}front`, "Front"),
      onClick: h
    }
  );
}, R = (t) => {
  const { viewer: o, translation: n, prefix: r, duration: e } = t, { view: i } = o, s = v(), h = d(() => {
    i.setViewOrientation(s.ViewOrientation.Back, e);
  }, [s.ViewOrientation.Back, e, i]);
  return /* @__PURE__ */ a(
    l,
    {
      x: 1,
      y: 0,
      hoverX: 0,
      hoverY: 0,
      title: c(n, `${r}back`, "Back"),
      onClick: h
    }
  );
}, B = (t) => {
  const { viewer: o, translation: n, prefix: r, duration: e } = t, { view: i } = o, s = v(), h = d(() => {
    i.setViewOrientation(s.ViewOrientation.Top, e);
  }, [s.ViewOrientation.Top, e, i]);
  return /* @__PURE__ */ a(
    l,
    {
      x: 3,
      y: 7,
      hoverX: 2,
      hoverY: 7,
      title: c(n, `${r}top`, "Top"),
      onClick: h
    }
  );
}, L = (t) => {
  const { translation: o, prefix: n } = t;
  return /* @__PURE__ */ a(
    l,
    {
      x: 8,
      y: 1,
      hoverX: 8,
      hoverY: 0,
      title: c(o, `${n}model_display`, "Model Display")
    }
  );
}, j = (t) => {
  const { viewer: o, translation: n, prefix: r } = t, { view: e } = o, i = v(), s = d(() => {
    e.setDrawMode(i.DrawMode.WireframeOnShaded);
  }, [i.DrawMode.WireframeOnShaded, e]);
  return /* @__PURE__ */ a(
    l,
    {
      x: 8,
      y: 3,
      hoverX: 8,
      hoverY: 2,
      title: c(n, `${r}solid_with_edges`, "Solid With Edges"),
      onClick: s
    }
  );
}, T = (t) => {
  const { viewer: o, translation: n, prefix: r } = t, { view: e } = o, i = v(), s = d(() => {
    e.setDrawMode(i.DrawMode.Shaded);
  }, [i.DrawMode.Shaded, e]);
  return /* @__PURE__ */ a(
    l,
    {
      x: 7,
      y: 6,
      hoverX: 6,
      hoverY: 6,
      title: c(n, `${r}solid_without_edges`, "Solid Without Edges"),
      onClick: s
    }
  );
}, W = (t) => {
  const { viewer: o, translation: n, prefix: r } = t, { view: e } = o, i = v(), s = d(() => {
    e.setDrawMode(i.DrawMode.HiddenLine);
  }, [i.DrawMode.HiddenLine, e]);
  return /* @__PURE__ */ a(
    l,
    {
      x: 1,
      y: 2,
      hoverX: 0,
      hoverY: 2,
      title: c(n, `${r}ghosted`, "Ghosted"),
      onClick: s
    }
  );
}, E = (t) => {
  const { viewer: o, translation: n, prefix: r } = t, { view: e } = o, i = v(), s = d(() => {
    e.setDrawMode(i.DrawMode.Wireframe);
  }, [i.DrawMode.Wireframe, e]);
  return /* @__PURE__ */ a(
    l,
    {
      x: 8,
      y: 1,
      hoverX: 8,
      hoverY: 0,
      title: c(n, `${r}wireframe`, "Wireframe"),
      onClick: s
    }
  );
}, z = (t) => {
  const { translation: o, prefix: n } = t;
  return /* @__PURE__ */ a(
    l,
    {
      x: 1,
      y: 1,
      hoverX: 0,
      hoverY: 1,
      title: c(o, `${n}section_planes`, "Section planes")
    }
  );
}, G = (t) => {
  const { controller: o, translation: n, prefix: r } = t, e = d(() => {
    o.toggle(x.X);
  }, [o]);
  return /* @__PURE__ */ a(
    l,
    {
      x: 1,
      y: 1,
      hoverX: 0,
      hoverY: 1,
      title: c(n, `${r}create_x_axis_section_plane`, "Create X-Axis Section Plane"),
      onClick: e
    }
  );
}, N = (t) => {
  const { controller: o, translation: n, prefix: r } = t, e = d(() => {
    o.toggleReferenceGeometry();
  }, [o]);
  return /* @__PURE__ */ a(
    l,
    {
      x: 8,
      y: 8,
      hoverX: 8,
      hoverY: 8,
      title: c(n, `${r}hide_section_planes`, "Hide Section Planes"),
      onClick: e
    }
  );
}, Z = (t) => {
  const { controller: o, translation: n, prefix: r } = t, e = d(() => {
    o.toggle(x.Y);
  }, [o]);
  return /* @__PURE__ */ a(
    l,
    {
      x: 8,
      y: 5,
      hoverX: 8,
      hoverY: 5,
      title: c(n, `${r}create_y_axis_section_plane`, "Create Y-Axis Section Plane"),
      onClick: e
    }
  );
}, q = (t) => {
  const { controller: o, translation: n, prefix: r } = t, e = d(() => {
    o.toggleCuttingMode();
  }, [o]);
  return /* @__PURE__ */ a(
    l,
    {
      x: 8,
      y: 7,
      hoverX: 8,
      hoverY: 7,
      title: c(n, `${r}show_section_planes`, "Show Section Planes"),
      onClick: e
    }
  );
}, J = (t) => {
  const { controller: o, translation: n, prefix: r } = t, e = d(() => {
    o.toggle(x.Z);
  }, [o]);
  return /* @__PURE__ */ a(
    l,
    {
      x: 8,
      y: 4,
      hoverX: 8,
      hoverY: 4,
      title: c(n, `${r}create_z_axis_section_plane`, "Create Z-Axis Section Plane"),
      onClick: e
    }
  );
}, K = (t) => {
  const { controller: o, translation: n, prefix: r } = t, e = d(() => {
    o.resetCuttingPlanes();
  }, [o]);
  return /* @__PURE__ */ a(
    l,
    {
      x: 7,
      y: 8,
      hoverX: 7,
      hoverY: 8,
      title: c(n, `${r}remove_all_section_planes`, "Remove All Section Planes"),
      onClick: e
    }
  );
}, Q = (t) => {
  const { translation: o, prefix: n } = t;
  return /* @__PURE__ */ a(
    l,
    {
      x: 3,
      y: 3,
      hoverX: 2,
      hoverY: 3,
      title: c(o, `${n}measurement_tools`, "Measurement Tools")
    }
  );
}, U = (t) => {
  const { translation: o, prefix: n, active: r, onClick: e } = t, i = v(), s = d(() => {
    e(i.OperatorId.MeasureEdgeLength);
  }, [i.OperatorId.MeasureEdgeLength, e]);
  return /* @__PURE__ */ a(
    l,
    {
      x: 5,
      y: 3,
      hoverX: 4,
      hoverY: 3,
      title: c(o, `${n}edge_length`, "Edge Length"),
      active: r,
      onClick: s
    }
  );
}, ee = (t) => {
  const { translation: o, prefix: n, active: r, onClick: e } = t, i = v(), s = d(() => {
    e(i.OperatorId.MeasureFaceFaceDistance);
  }, [i.OperatorId.MeasureFaceFaceDistance, e]);
  return /* @__PURE__ */ a(
    l,
    {
      x: 3,
      y: 3,
      hoverX: 2,
      hoverY: 3,
      active: r,
      title: c(o, `${n}face_to_face_distance`, "Face to Face distance"),
      onClick: s
    }
  );
}, oe = (t) => {
  const { translation: o, prefix: n, active: r, onClick: e } = t, i = v(), s = d(() => {
    e(i.OperatorId.MeasureFaceFaceAngle);
  }, [i.OperatorId.MeasureFaceFaceAngle, e]);
  return /* @__PURE__ */ a(
    l,
    {
      x: 1,
      y: 3,
      hoverX: 0,
      hoverY: 3,
      active: r,
      title: c(o, `${n}face_to_face_angle`, "Face to Face angle"),
      onClick: s
    }
  );
}, te = (t) => {
  const { translation: o, prefix: n, active: r, onClick: e } = t, i = v(), s = d(() => {
    e(i.OperatorId.MeasurePointPointDistance);
  }, [i.OperatorId.MeasurePointPointDistance, e]);
  return /* @__PURE__ */ a(
    l,
    {
      x: 7,
      y: 3,
      hoverX: 6,
      hoverY: 3,
      active: r,
      title: c(o, `${n}point_to_point_distance`, "Point to Point distance"),
      onClick: s
    }
  );
}, ne = (t) => {
  const { translation: o, prefix: n, onClick: r } = t, e = v(), i = d(() => {
    r(e.OperatorId.None);
  }, [e.OperatorId.None, r]);
  return /* @__PURE__ */ a(
    l,
    {
      x: 7,
      y: 8,
      hoverX: 7,
      hoverY: 8,
      title: c(o, `${n}remove_all_measurements`, "Remove all measurements"),
      onClick: i
    }
  );
};
export {
  te as A,
  ne as B,
  Y as H,
  M as a,
  P as b,
  $ as c,
  b as d,
  S as e,
  D as f,
  F as g,
  A as h,
  R as i,
  B as j,
  L as k,
  j as l,
  T as m,
  W as n,
  E as o,
  z as p,
  G as q,
  N as r,
  Z as s,
  q as t,
  J as u,
  K as v,
  Q as w,
  U as x,
  ee as y,
  oe as z
};
//# sourceMappingURL=HoopsViewerRemoveMeasurementsIcon-CgwjpIWI.js.map
